export const en = {
    category: 'Categories',
    selected: 'Selected',
    zones: 'Zones'
};
